"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userCertificatesController = function () {
  function userCertificatesController() {
    "ngInject";

    (0, _classCallCheck3.default)(this, userCertificatesController);
  }

  (0, _createClass3.default)(userCertificatesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.gridOptions = {
        dataSource: this.certificates,
        sortable: true,
        pageable: false,
        resizable: true,
        noRecords: {
          template: "No Certificates."
        },
        columns: [{ field: "category", title: "Category", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getCategory(dataItem.category);
          } }, { field: "certificateTypeId", title: "Certificate Type", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getCertificateType(dataItem.certificateTypeId);
          } }, { field: "certificateNumber", title: "Certificate Number", filterable: false, width: "4rem" }, { field: "certificateStatus", title: "Certificate Status", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getCertificateStatus(dataItem.certificateStatus);
          } }, { field: "expiryDate", title: "Expiry Date", filterable: false, width: "4rem", template: "#= expiryDate ? kendo.toString(new Date(expiryDate), 'dd/MM/yyyy'): '-' #" }, { field: "verificationDate", title: "Verification Date", filterable: false, width: "4rem", template: "#= verificationDate ? kendo.toString(new Date(verificationDate), 'dd/MM/yyyy'): '-' #" }]
      };
    }
  }, {
    key: "_getCertificateStatus",
    value: function _getCertificateStatus(status) {
      switch (status) {
        case _constants2.default.certificateStatus.PENDINGVERIFICATION:
          return "Pending Verification";
        case _constants2.default.certificateStatus.ACTIVE:
          return "Active";
        case _constants2.default.certificateStatus.INVALID:
          return "Invalid";
        case _constants2.default.certificateStatus.EXPIRED:
          return "Expired";
      }
    }
  }, {
    key: "_getCategory",
    value: function _getCategory(category) {
      switch (category) {
        case _constants2.default.certificateCategory.CHECK:
          return "Check";
        case _constants2.default.certificateCategory.FIRSTAID:
          return "First Aid";
        case _constants2.default.certificateCategory.QUALIFICATION:
          return "Qualification";
      }
    }
  }, {
    key: "_getCertificateType",
    value: function _getCertificateType(type) {
      switch (type) {
        case _constants2.default.certificateType.WWCC:
          return "WWCC";
      }
    }
  }]);
  return userCertificatesController;
}();

exports.default = userCertificatesController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-certificates/user-certificates.controller.js
 **/